(function imageViewer(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.FullImageViewerState ||
    !global.NewHomeSource.FullImageViewer.Config ||
    !global.NewHomeSource.Pipe ||
    !global.NewHomeSource.Modules.ImageHandler) {
    return;
  }

  const previousImageViewer = global.NewHomeSource.ImageViewer;
  const mediaBreakpoints = [768, 1024, 1440];
  const pictureElement = global.document.querySelector('[data-full-image-viewer-role="viewer"]');
  const addJpgParameter = global.NewHomeSource.Modules.ImageHandler.addJpgParameter;

  /**
   * @private
   * createSource: create a source that can be added to a picture element.
   *
   * @param {string} url the image url to be used as scrset.
   */
  function createSource(pixels) {
    const source = global.document.createElement('SOURCE');
    const oneX = '?maxWidth=' + pixels + ' 1x';
    const twoX = '?maxWidth=' + (pixels * 2) + ' 2x';

    source.media = '(max-width:' + pixels + 'px)';
    source.type = 'image/jpg';
    source.srcset = this + oneX + ', ' + this + twoX;

    pictureElement.appendChild(source);
  }

  /**
   * @private
   * render: renders the information of the image inside ImageViewer picture element.
   *
   * @param {*} image with the information needed to fill the Image Viewer picture element.
   */
  function render(image) {
    const maxResolution = addJpgParameter(image.Source, 'maxWidth=1920');
    const maxResolutionx2 = addJpgParameter(image.Source, 'maxWidth=3940');
    const source = global.document.createElement('SOURCE');
    const img = global.document.createElement('IMG');
    pictureElement.innerHTML = '';
    source.media = '(min-width:' + 1441 + 'px)';
    source.type = 'image/jpg';
    source.srcset = maxResolution + ' 1x, ' + maxResolutionx2 + ' 2x';
    img.src = maxResolution;
    img.alt = image.Alt;

    mediaBreakpoints.forEach(createSource.bind(image.Source));
    pictureElement.appendChild(source);
    pictureElement.appendChild(img);
    pictureElement.style.display = 'block';
  }

  /**
  * @private
  * hidePicture: this method hides the picture element from the full image viewer
  * if the current element to display is not an image.
  *
  * @param {boolean} isPicture true if the current element is a picture, false otherwise.
  */
  function hidePicture(isPicture) {
    if (isPicture) {
      return;
    }

    pictureElement.style.display = 'none';
  }

  /**
  * @private
  * displayPicture: this method shows the picture element from the full image viewer
  * if the current element to display is an image.
  *
  * @param {object} data information that was changed.
  */
  function displayPicture(data) {
    requestAnimationFrame(render.bind(this, data));
  }

  /**
  * @private
  * shouldBeIgnored: hides the Picture element if the current element data is not of picture type.
  *
  * @param {object} data information that was changed.
  */
  function shouldBeIgnored(data) {
    const isZoomable = global.NewHomeSource.FullImageViewer.Zoom &&
      global.NewHomeSource.FullImageViewer.Config.isZoomableCollection(data);
    const isPicture = !data.IsFrame &&
      !isZoomable &&
      !data.VideoType &&
      !data.IsOtherMedia &&
      data.Collection.toLowerCase() !== 'other';

    hidePicture(isPicture);
    return isPicture;
  }

  /**
   * @constructs NewHomeSource.ImageViewer
   */
  function ImageViewer() {
  }

  /**
   * @public
   * update: this method will be called by the Event Bus when the data is updated.
   *
   * @param {object} data information that was changed.
   */
  ImageViewer.update = function update(data) {
    global.NewHomeSource.Pipe.conditionalPipe(shouldBeIgnored, displayPicture)(data);
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.SampleModule to the previous script.
   */
  ImageViewer.noConflict = function noConflict() {
    global.NewHomeSource.ImageViewer = previousImageViewer;
    return ImageViewer;
  };

  global.NewHomeSource.FullImageViewerState.add('onImageSet', ImageViewer);
  global.NewHomeSource.ImageViewer = ImageViewer;
}(window));
